{
  "ai_evaluating_description": "Обрабатываем ответы и готовим для вас инсайты. Это может занять несколько минут.",
  "ai_evaluating_title": "ИИ анализирует ответы",
  "ai_summary_highlights_description": "Что особенно выделялось в ответах",
  "ai_summary_highlights_title": "Главное от %APP_AI_NAME%",
  "ai_waiting_description": "Анализ начнется автоматически после завершения опроса.",
  "ai_waiting_title": "ИИ ждет завершения опроса",
  "assistant": "Ассистент",
  "assistant_action_approve_time_off_request": "Согласовать заявку на отпуск",
  "assistant_action_cancel_time_off_request": "Отменить заявку на отпуск",
  "assistant_action_cancelled": "Действие отменено.",
  "assistant_action_checkin_goal": "Отметить прогресс по цели",
  "assistant_action_create_form_scale": "Создать шкалу оценки",
  "assistant_action_create_form_template": "Создать шаблон формы",
  "assistant_action_create_form_template_folder": "Создать папку шаблонов",
  "assistant_action_create_goal": "Создать цель",
  "assistant_action_create_key_result": "Добавить ключевой результат",
  "assistant_action_create_performance_review_draft": "Создать черновик ревью",
  "assistant_action_create_survey_draft": "Создать черновик опроса",
  "assistant_action_create_time_off_request": "Оформить заявку на отпуск",
  "assistant_action_default": "Подтвердите действие",
  "assistant_action_done": "Готово.",
  "assistant_action_duplicate_form_template": "Скопировать шаблон формы",
  "assistant_action_duplicate_performance_review": "Скопировать ревью",
  "assistant_action_duplicate_survey": "Скопировать опрос",
  "assistant_action_failed": "Не удалось выполнить действие.",
  "assistant_action_give_recognition": "Отправить признание",
  "assistant_action_move_form_template": "Перенести шаблон формы",
  "assistant_action_open": "Открыть",
  "assistant_action_reject_time_off_request": "Отклонить заявку на отпуск",
  "assistant_action_update_form_template": "Обновить шаблон формы",
  "assistant_action_update_form_template_form": "Обновить вопросы шаблона",
  "assistant_action_update_goal": "Изменить цель",
  "assistant_action_update_key_result": "Изменить ключевой результат",
  "assistant_action_update_performance_review": "Обновить ревью",
  "assistant_action_update_performance_review_form": "Обновить форму ревью",
  "assistant_action_update_survey": "Обновить опрос",
  "assistant_action_update_survey_form": "Обновить вопросы опроса",
  "assistant_attach_file": "Приложить файл",
  "assistant_busy": "Ассистент ещё отвечает. Дождитесь ответа или остановите его.",
  "assistant_cancel_all": "Отменить все",
  "assistant_confirm_all": "Подтвердить все ({count})",
  "assistant_disclaimer": "%APP_ASSISTANT_NAME% — это ИИ, он может ошибаться",
  "assistant_download_csv": "Скачать CSV",
  "assistant_empty": "Спросите о коллегах, отпусках, целях, ревью, опросах и аналитике. Я также могу оформить и согласовать отпуск, настроить опрос или ревью по шаблону, отредактировать шаблон формы, отправить признание, обновить цель и прочитать ваш файл.",
  "assistant_error": "Ассистент сейчас не может ответить. Попробуйте ещё раз.",
  "assistant_feature_description": "Сотрудники спрашивают ассистента о целях, коллегах и отпусках и отмечают прогресс по целям, не уходя со страницы",
  "assistant_feature_title": "AI-ассистент",
  "assistant_field_anonymous_threshold": "Порог анонимности",
  "assistant_field_comment": "Комментарий",
  "assistant_field_create_new_form": "Начать с пустой формы",
  "assistant_field_date_ends_at": "Окончание",
  "assistant_field_date_from": "С",
  "assistant_field_date_starts_at": "Начало",
  "assistant_field_date_to": "По",
  "assistant_field_emoji": "Эмодзи",
  "assistant_field_form": "Вопросы",
  "assistant_field_invitation": "Приглашение",
  "assistant_field_invitation_body": "Текст приглашения",
  "assistant_field_invitation_subject": "Тема приглашения",
  "assistant_field_is_share_employee_after_completion": "Показать результаты после завершения",
  "assistant_field_items": "{count, plural, one {# элемент} few {# элемента} many {# элементов} other {# элемента}}",
  "assistant_field_options": "Варианты",
  "assistant_field_participant_reviewers": "Оценщики",
  "assistant_field_participants_rule_groups": "Участники",
  "assistant_field_questions": "{count, plural, one {# вопрос} few {# вопроса} many {# вопросов} other {# вопроса}}",
  "assistant_field_ratings": "Оценки",
  "assistant_field_reminders": "Напоминания",
  "assistant_field_reviewer_types": "Типы оценщиков",
  "assistant_field_share_employee_rule_groups": "Кому видны результаты",
  "assistant_field_target_type": "Скопировать как",
  "assistant_field_type": "Тип",
  "assistant_field_use_ai": "AI-сводка",
  "assistant_file_too_large": "Файл больше 4,5 МБ.",
  "assistant_file_type_unsupported": "Этот тип файла не поддерживается. Приложите xlsx, xls, csv, pdf, docx или txt.",
  "assistant_greeting": "Привет, я %APP_ASSISTANT_NAME%",
  "assistant_input_placeholder": "Спросите %APP_ASSISTANT_NAME%",
  "assistant_interrupted": "Ответ прерван.",
  "assistant_limit_exceeded": "Лимит запросов к ассистенту на этот период исчерпан. Чтобы увеличить его, обратитесь к администратору.",
  "assistant_name": "%APP_ASSISTANT_NAME%",
  "assistant_permission_description": "Разрешить пользователям задавать вопросы AI-ассистенту",
  "assistant_permission_title": "Доступ к ассистенту",
  "assistant_question_too_long": "Вопрос длиннее 8000 символов. Сократите его.",
  "assistant_resize": "Изменить ширину панели ассистента",
  "assistant_retry": "Повторить",
  "assistant_send": "Отправить",
  "assistant_show_all_rows": "Показать все ({count})",
  "assistant_stop": "Остановить",
  "assistant_stopped": "Остановлено.",
  "assistant_suggestion_checkin": "Отметь прогресс по моей цели",
  "assistant_suggestion_goals": "Какие у меня цели и что отстаёт?",
  "assistant_suggestion_review": "Как моя команда прошла последнее ревью?",
  "assistant_suggestion_time_off": "Кто в отпуске на этой неделе?",
  "assistant_thinking": "Думает…",
  "assistant_thread_delete": "Удалить диалог",
  "assistant_thread_delete_confirm": "Удалить диалог? Восстановить его будет нельзя.",
  "assistant_thread_new": "Новый диалог",
  "assistant_threads": "Диалоги",
  "assistant_threads_empty": "Диалогов пока нет.",
  "assistant_title": "Спросить %APP_ASSISTANT_NAME%",
  "assistant_tool_approve_time_off_request": "Согласую заявку на отпуск…",
  "assistant_tool_cancel_time_off_request": "Отменяю заявку на отпуск…",
  "assistant_tool_check_time_off_request": "Проверяю заявку на отпуск…",
  "assistant_tool_checkin_goal": "Отмечаю прогресс по цели…",
  "assistant_tool_create_form_scale": "Создаю шкалу оценки…",
  "assistant_tool_create_form_template": "Создаю шаблон формы…",
  "assistant_tool_create_form_template_folder": "Создаю папку шаблонов…",
  "assistant_tool_create_goal": "Создаю цель…",
  "assistant_tool_create_key_result": "Добавляю ключевой результат…",
  "assistant_tool_create_performance_review_draft": "Создаю черновик ревью…",
  "assistant_tool_create_survey_draft": "Создаю черновик опроса…",
  "assistant_tool_create_time_off_request": "Оформляю заявку на отпуск…",
  "assistant_tool_default": "Работаю с данными…",
  "assistant_tool_done": "готово",
  "assistant_tool_duplicate_form_template": "Копирую шаблон формы…",
  "assistant_tool_duplicate_performance_review": "Копирую ревью…",
  "assistant_tool_duplicate_survey": "Копирую опрос…",
  "assistant_tool_failed": "ошибка",
  "assistant_tool_get_employee": "Смотрю профиль сотрудника…",
  "assistant_tool_get_employee_by_email": "Ищу сотрудника по email…",
  "assistant_tool_get_employee_time_off_balance": "Смотрю баланс отпусков…",
  "assistant_tool_get_employee_time_off_calendar": "Смотрю календарь отсутствий…",
  "assistant_tool_get_form_template": "Открываю шаблон формы…",
  "assistant_tool_get_goal": "Смотрю цель…",
  "assistant_tool_get_help_article": "Читаю статью справки…",
  "assistant_tool_get_me": "Смотрю ваш профиль…",
  "assistant_tool_get_my_inbox": "Смотрю ваши входящие…",
  "assistant_tool_get_performance_review_form": "Открываю форму ревью…",
  "assistant_tool_get_performance_review_participant_report": "Смотрю отчёт участника ревью…",
  "assistant_tool_get_performance_review_results": "Смотрю результаты ревью…",
  "assistant_tool_get_performance_review_setup": "Открываю настройки ревью…",
  "assistant_tool_get_performance_review_stats": "Смотрю статистику ревью…",
  "assistant_tool_get_survey_form": "Открываю форму опроса…",
  "assistant_tool_get_survey_results": "Смотрю результаты опроса…",
  "assistant_tool_get_survey_setup": "Открываю настройки опроса…",
  "assistant_tool_give_recognition": "Отправляю признание…",
  "assistant_tool_list_analytics_columns": "Смотрю колонки аналитики…",
  "assistant_tool_list_employee_columns": "Смотрю колонки сотрудников…",
  "assistant_tool_list_employee_time_off_categories": "Смотрю типы отсутствий…",
  "assistant_tool_list_form_template_folders": "Смотрю папки шаблонов…",
  "assistant_tool_list_performance_review_participants": "Смотрю участников ревью…",
  "assistant_tool_list_rule_conditions": "Смотрю условия отбора…",
  "assistant_tool_move_form_template": "Переношу шаблон формы…",
  "assistant_tool_preview_performance_review_change": "Проверяю изменения ревью…",
  "assistant_tool_preview_rules": "Проверяю, кто подходит…",
  "assistant_tool_preview_survey_change": "Проверяю изменения опроса…",
  "assistant_tool_query_people_analytics": "Считаю аналитику по людям…",
  "assistant_tool_reject_time_off_request": "Отклоняю заявку на отпуск…",
  "assistant_tool_search_employee_time_off": "Ищу отсутствия…",
  "assistant_tool_search_employees": "Ищу сотрудников…",
  "assistant_tool_search_form_scales": "Ищу шкалы оценки…",
  "assistant_tool_search_form_templates": "Ищу шаблоны форм…",
  "assistant_tool_search_goals": "Ищу цели…",
  "assistant_tool_search_help": "Ищу в справке…",
  "assistant_tool_search_performance_reviews": "Ищу ревью…",
  "assistant_tool_search_recognitions": "Ищу признания…",
  "assistant_tool_search_rule_condition_options": "Ищу значения условий…",
  "assistant_tool_search_survey_answers": "Ищу ответы в опросе…",
  "assistant_tool_search_survey_participants": "Ищу участников опроса…",
  "assistant_tool_search_surveys": "Ищу опросы…",
  "assistant_tool_search_time_off_calendar": "Ищу в календаре отсутствий…",
  "assistant_tool_update_form_template": "Обновляю шаблон формы…",
  "assistant_tool_update_form_template_form": "Обновляю вопросы шаблона…",
  "assistant_tool_update_goal": "Обновляю цель…",
  "assistant_tool_update_key_result": "Обновляю ключевой результат…",
  "assistant_tool_update_performance_review": "Обновляю ревью…",
  "assistant_tool_update_performance_review_form": "Обновляю форму ревью…",
  "assistant_tool_update_survey": "Обновляю опрос…",
  "assistant_tool_update_survey_form": "Обновляю вопросы опроса…",
  "assistant_value_double_scale": "Двойная шкала",
  "assistant_value_performance_review": "Ревью",
  "assistant_value_single_scale": "Одна шкала",
  "assistant_value_survey": "Опрос",
  "based_on_ai": "Основано на анализе %APP_AI_NAME%",
  "calculate": "Рассчитать",
  "calculating_match": "Расчет соответствия...",
  "calculating_match_description": "Может занять до 10 минут",
  "calculation_failed": "Ошибка расчета",
  "calculation_failed_description": "Не удалось рассчитать оценку. Попробуйте еще раз",
  "edit_score": "Изменить оценку",
  "match_not_calculated": "Соответствие не рассчитано",
  "match_score": "Оценка соответствия",
  "match_title": "",
  "recalculate": "Пересчитать",
  "request_calculate": "Запросить расчет",
  "~": "~"
}
